import { Component, inject } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { MenuComponent } from './components/molecules/menu/menu.component';
import { LoginComponent } from './components/organisms/login/login.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { StoreImpersonationHeaderComponent } from './components/molecules/store-impersonation-header/store-impersonation-header.component';
import {
  GlobalDataService,
  SessionData,
} from './services/global-data/global-data.service';
import { BehaviorSubject } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { permissionRedirect, routePermission } from './guards/administration/administration.guard';
import { environment } from '../environments/environment';
import { SamSessionService } from './services/auth/sam-session.service';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  imports: [
    RouterOutlet,
    RouterLink,
    MenuComponent,
    LoginComponent,
    NgxSkeletonLoaderModule,
    StoreImpersonationHeaderComponent,
    AsyncPipe,
  ],
})
export class AppComponent {
  readonly signedOutInAnotherTab = inject(SamSessionService).signedOutInAnotherTab;
  title = 'Store Activation Module';
  sessionData$: BehaviorSubject<SessionData> =
    this.globalDataService.getSessionData();

  accessRevoked(session: SessionData | null): boolean {
    const route = this.router.routerState.snapshot.root.firstChild;
    const permission = route && routePermission(route);
    return !!(session?.initialized && permission && permission !== 'no-access' &&
      permissionRedirect(permission, session));
  }

  constructor(private globalDataService: GlobalDataService, private router: Router) {
    console.log('Env is ', environment.title);
  }
}
